import { render, staticRenderFns } from "./MulUploadLicese.vue?vue&type=template&id=0244b562&"
import script from "./MulUploadLicese.vue?vue&type=script&lang=ts&"
export * from "./MulUploadLicese.vue?vue&type=script&lang=ts&"
import style0 from "./MulUploadLicese.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports